import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, User } from "lucide-react";
import { Button } from "@/components/ui/button";

const Header = ({ onGetStarted }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100" data-testid="header">
      <div className="container-main">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2" data-testid="header-logo">
            <span className="text-xl md:text-2xl font-bold text-[#0F172A]">
              Solve<span className="text-[#10B981]">Debts</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <a href="#calculator-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981] transition-colors">
              Calculator
            </a>
            <a href="#trust-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981] transition-colors">
              Why Us
            </a>
            <a href="#faq-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981] transition-colors">
              FAQs
            </a>
          </nav>

          {/* CTA Buttons */}
          <div className="flex items-center gap-3">
            <Link to="/login">
              <Button variant="outline" className="hidden sm:flex items-center gap-2" data-testid="client-portal-btn">
                <User className="w-4 h-4" />
                Client Portal
              </Button>
            </Link>
            <Button
              onClick={onGetStarted}
              className="bg-[#10B981] hover:bg-[#059669] text-white text-sm px-4 py-2 rounded-lg"
              data-testid="header-cta"
            >
              Free Assessment
            </Button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-slate-600"
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-100">
            <nav className="flex flex-col gap-4">
              <a href="#calculator-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981]" onClick={() => setMobileMenuOpen(false)}>
                Calculator
              </a>
              <a href="#trust-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981]" onClick={() => setMobileMenuOpen(false)}>
                Why Us
              </a>
              <a href="#faq-section" className="text-sm font-medium text-slate-600 hover:text-[#10B981]" onClick={() => setMobileMenuOpen(false)}>
                FAQs
              </a>
              <Link to="/login" className="text-sm font-medium text-slate-600 hover:text-[#10B981]" onClick={() => setMobileMenuOpen(false)}>
                Client Portal
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
